import { render } from "./CustomsExportImport.vue?vue&type=template&id=4c59256a&scoped=true"
import script from "./CustomsExportImport.vue?vue&type=script&lang=js"
export * from "./CustomsExportImport.vue?vue&type=script&lang=js"

import "./CustomsExportImport.vue?vue&type=style&index=0&id=4c59256a&lang=scss&scoped=true"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c59256a"]])

export default __exports__